// extracted by mini-css-extract-plugin
export default {"relationForm":"relationForm-JT0nD","content":"content-XSiBQ","body":"body-Yp3iZ","relatedBlock":"relatedBlock-s_ZCw","disrelatedBlock":"disrelatedBlock-kGSak","flag":"flag-C2kzH"};